import React, { useState } from 'react';
import './AdminTestStyles.css';
import UpgradeModal from '../UpgradeModal';

function AdminTestPasswordPrompt({ onPasswordSubmit }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!password) {
      setError('Please enter a password');
      return;
    }

    // Store password in localStorage
    localStorage.setItem('adminTestsPassword', password);

    // Call parent callback to trigger re-render
    onPasswordSubmit(password);
  };

  // Show upgrade modal if user doesn't know the password
  if (showUpgradeModal) {
    return <UpgradeModal featureName="Admin Tests" />;
  }

  return (
    <div className="password-prompt-overlay">
      <div className="password-prompt-modal">
        <div className="password-prompt-header">
          <h2>Admin Tests Access</h2>
          <p>Enter the password to access admin tests and data loading</p>
        </div>

        <form onSubmit={handleSubmit} className="password-prompt-form">
          <div className="password-input-group">
            <input
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError('');
              }}
              placeholder="Enter password"
              className="password-input"
              autoFocus
            />
          </div>

          {error && (
            <div className="password-error">
              {error}
            </div>
          )}

          <button type="submit" className="password-submit-btn">
            Access Admin Tests
          </button>

          <div className="password-dont-know">
            <button
              type="button"
              onClick={() => setShowUpgradeModal(true)}
              className="password-dont-know-link"
            >
              Don't know the password?
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AdminTestPasswordPrompt;
